// removed by extract-text-webpack-plugin
module.exports = {"option":"option___3vMnW","backer":"backer___3Fw9Z","select":"select___yH6p6","label":"label___2LvCS","switch":"switch___V_-aL","switchBtn":"switchBtn___31QvT"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/ChoiceFromDataSourceColumnEditor/styles.scss
// module id = 417
// module chunks = 0